module.exports = __webpack_public_path__ + "static/media/Burnt-Orange_2.622b2fdf.jpg";